import {
  DefaultFetchError,
  FetchGet,
  FetchGetId,
  PagingDataResponse,
  PagingParams,
  useFetchGet,
  useFetchGetId,
} from '../fetch';

export interface Tag {
  id: string;
  name: string;
}

export interface FileData {
  id: string;
  originalName: string;
  location: string;
  mimeType: string;
  createdAt: string; // ISO дата
}
export interface ArticlesData {
  data: Article[];
  total: number;
}

export type ArticleType = 'blog' | 'history' | 'psychology';
export interface WithArticleTypeProps {
  articleType: ArticleType;
}

export interface ArticleAuthorFields {
  authorImage: FileData | null;
  authorName: string;
  authorDescription: string;
}

export interface Article extends ArticleAuthorFields, WithArticleTypeProps {
  id: string;
  name: string;
  description: string;
  status: 'published' | 'draft' | 'archived';
  tags: Tag[];
  file: FileData;
  video: FileData;

  createdAt: string;
  updatedAt: string;
}

export interface TagsData {
  data: Tag[];
}

export const useArticlesTagsGetAll = (): FetchGet<TagsData, DefaultFetchError> => (
  useFetchGet('articles/tags?pageSize=100', { authorization: false })
);

export interface ArticlesResponse extends Article {
  key: string;
}
interface ArticlesDataParams extends PagingParams {
  orderByColumn?: 'createdAt';
}

export const useArticlesGetById = <DD = Article>(
  id?: string,
  decorateData?: (data: Article) => DD,
): FetchGetId<
  Article,
  DefaultFetchError,
  unknown,
  DD
> => useFetchGetId(
    'articles',
    id,
    {
      authorization: false,
      autoStart: !!id,
      decorateData,
    },
  );

export const useArticlesGet = <DD = ArticlesData>(
  decorateData?: (data: PagingDataResponse<Article>) => DD,
): FetchGet<
  PagingDataResponse<Article>,
  ArticlesDataParams,
  DefaultFetchError,
  DD
> => useFetchGet(
    'articles',
    {
      autoStart: false,
      startStateLoading: false,
      decorateData,
      authorization: false,
      config: {
        params: {
          orderBy: 'DESC',
          status: 'published',
          articleType: 'blog',
        },
      },
    },
  );

export const useArticlesGetAll = () => useArticlesGet<ArticlesData>(
  ({ data, meta }: PagingDataResponse<Article>): ArticlesData => ({
    data: data.map((item: Article): ArticlesResponse => ({
      key: item.id,
      ...item,
    })),
    total: meta.itemCount,
  }),
);
